<template>
  <div class="month-review-intro">
    <information button-title="איך הסתיים החודש האחרון?"
                 :button-action="next"
                 secondary-button-title="לדלג לחודש הנוכחי"
                 :secondary-button-action="skipToCashflow"
                 img-name="past_month_balance.svg">
      <template v-slot:information-title>
        <div>
          הדרך לשינוי גדול מתחילה בצעדים קטנים - קודם כל ננצח את החודש!
        </div>
      </template>
      <template v-slot:information-description>
        <div class="description-first-row">
          <span>המטרה שלנו - </span>
          <span class="bold">להוציא כל חודש פחות כסף משנכנס</span>
          <span>ולסיים בתזרים חודשי חיובי.</span>
        </div>
        <div>
          נתחיל בלראות איך הסתיים החודש האחרון.
        </div>
      </template>
    </information>
  </div>
</template>
<script>

import Information from '../../onboard2/steps/components/Information';
import Segment from '../../../../../Segment';

export default {
  components: {
    Information,
  },
  name: 'MonthReviewIntro',
  async created() {
    Segment.trackUserGot('MonthReviewIntroEntered');
  },
  methods: {
    next() {
      Segment.trackUserInteraction('MonthReviewIntroNextClicked');
      this.$emit('done');
    },
    skipToCashflow() {
      Segment.trackUserInteraction('MonthReviewSkipToCashflowClicked');
      this.$emit('skip-to-cashflow');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';

.month-review-intro {
  height: 100%;

  .description-first-row {
    margin-bottom: 30px;
  }

  ::v-deep .information {

    .body {
      background-color: $riseup_light_blue;

      .title {
        padding: 0;
        white-space: normal;
      }
    }

    .image-container{
      padding: 0 54px;
      background-color: $riseup_light_blue;
    }

    img {
      background-color: $riseup_light_blue;
    }

    .footer {
      padding: 24px 20px 5px 20px;

      .riseup-button {
        height: 54px;
        width: 100%;

        .button-titles {
          .button-title {
            font-size: 18px;
          }
        }
      }
    }
  }
}

</style>
